
const initialState = {
   
}


export default function userReducer(state=initialState,action){
    switch(action.type){
        case "SET_USER":
        return {
            ...action.payload
        }
        case "RESET_USER":
            return initialState;
        case "UPDATE_COINS":{
            return{
                ...state,
                coins:state.coins + action.payload,
                lastQuiz:Date.now()
            }
        }
        default :
        return state;
    }
}